import { render } from "./EmbeddableWidgetPage.vue?vue&type=template&id=d0c61922&scoped=true"
import script from "./EmbeddableWidgetPage.vue?vue&type=script&lang=js"
export * from "./EmbeddableWidgetPage.vue?vue&type=script&lang=js"

import "./EmbeddableWidgetPage.vue?vue&type=style&index=0&id=d0c61922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0c61922"]])

export default __exports__